import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSuperOpsTypes } from '@services/requests/superOps';

export const ThunkGetSuperOpsTypes = createAsyncThunk(
  'superOps/getSuperOpsTypes',
  crmId => getSuperOpsTypes(crmId),
);

export default {};
